document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.heading-container').forEach(heading => {
        heading.addEventListener('click', () => {
            if (window.innerWidth <= 989) {
                heading.parentNode.classList.toggle('active');
                for (const sibling of heading.parentNode.parentNode.children) {
                    if (sibling !== heading.parentNode) sibling.classList.remove('active');
                }
            }
        });
    });
});